import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getOSHData } from '../../api';

let linkCount = 0;

class NationalStrategiesReport extends Component
{
    constructor(props)
	{
		super(props);

        const countryNames = {
            "AT":"39",
			"BE":"46",
			"BG":"56",
			"CH":"224",
			"CY":"77",
			"CZ":"78",
			"DE":"100",
			"DK":"79",
			"EE":"88",
			"EL":"103",
			"ES":"218",
			"FI":"93",
			"FR":"94",
			"HR":"75",
			"HU":"116",
			"IE":"122",
			"IS":"117",
			"IT":"125",
			"LT":"144",
			"LU":"145",
			"LV":"138",
			"MT":"153",
			"NL":"172",
			"NO":"182",
			"PL":"191",
			"PT":"192",
			"RO":"196",
			"SE":"223",
			"SI":"214",
			"SK":"213",
            "EU27_2020":"822"
        }

        this.state = {
            country: {
                countryName: countryNames[props.country],
                code: props.country
            },            
            basicInfo: "",
            background: "",
            characteristicsObjectives: "",
            detailsActivity: "",
            actorsStakeholders: "",
            resourcesTimeframe: "",
            evaluation: "",
            relationStategicFramework: "",
            noteLinks: []
        }
	}

    checkLinks(htmlText)
    {
        let res = this.props.literals[ htmlText ];
        res = res.replace(/&quot;/g, '"');
        res = res.replace("<br>", "<br/>");
        res = res.replace(/&amp;/g, "&");

        let el = document.createElement("html");
        el.innerHTML = res;
        // Get the list of links in the text
        let anchors = el.getElementsByTagName("a");

        let noteLinks = [];

        Array.prototype.slice.call( anchors ).forEach( function( link ) {
            linkCount++;
            
            // Create the span with the link to the foot note that will replace the link
            let str = "<span>"+link.text+"<a href='#_ftn"+linkCount+"' name='B"+linkCount+"'><sup>"+linkCount+"</sup></a></span>";

            // The link can have a line break inside, replace it
            let outerHTML = link.outerHTML.replace("<br>", "<br/>");
            let outerClear = outerHTML.replace(/&amp;/g, "&");

            // Replace the link with the created span. First, check if the URL is encoded or not
            if (res.indexOf(outerClear) > -1)
            {
                res = res.replace(outerClear, str);
            }
            else
            {
                res = res.replace(outerHTML, str);
            }

            noteLinks.push(link.href);            
        });
        
        this.setState({ noteLinks: this.state.noteLinks.concat(noteLinks) });
        return res;
    }

    componentDidMount()
    {
        try
        {
            getOSHData('STRATEGY', {countries: [this.state.country]})
                .then((res) => {
                    // Only one country should be returned
                    if (res.resultset.length == 1)
                    {
                        this.setState({
                            basicInfo: this.checkLinks(`L${res.resultset[0].text1}`),
                            background: this.checkLinks(`L${res.resultset[0].text2}`),
                            characteristicsObjectives: this.checkLinks(`L${res.resultset[0].text3}`),
                            detailsActivity: this.checkLinks(`L${res.resultset[0].text4}`),
                            actorsStakeholders: this.checkLinks(`L${res.resultset[0].text5}`),
                            resourcesTimeframe: this.checkLinks(`L${res.resultset[0].text6}`),
                            evaluation: this.checkLinks(`L${res.resultset[0].text7}`),
                            relationStategicFramework: this.checkLinks(`L${res.resultset[0].text8}`)
                        });
                    }
                }
            );
        }
        catch (error)
        {
            console.log('Error fetching data:', error)
        }
    }

    render()
    {
        return (
            <table className="osh-authorities-report">
            <thead>
                <tr>
                    <td className="header">
                        <div className="logo"></div>
                        <p>{ this.props.literals['L20014'] } - { this.props.literals[`L${this.state.country.countryName}`] }</p>
                    </td>
                </tr>
            </thead>
            <tbody className="osh-authorities-report-page">
                <tr>
                    <td>
                        <h1>{ this.state.country.code == "EU27_2020" ? "Strategy mapping" : "National strategies mapping" }</h1>
                        <p className="description">{ this.state.country.code == "EU27_2020" ? this.props.literals['L20644'] : this.props.literals['L20015'] }</p>
                        <h2>{ this.props.literals[`L${this.state.country.countryName}`] }</h2>
                        {this.state.country.code == "EU27_2020" ? null :                        
                            <p>
                                <span className="source-label">Source:</span>
                                <a href="https://www.eurofound.europa.eu/country/eu-level#actors-and-institutions" className="source-url">https://www.eurofound.europa.eu/country/eu-level#actors-and-institutions</a>
                            </p>
                        }
                    </td>
                </tr>
                <tr>
                    <td>
                        <table className="national-strategies-report">
                            <tr>
                                <th>{ this.state.country.code == "EU27_2020" ? "" : "COUNTRY" }</th>
                                <th>{ this.props.literals[`L${this.state.country.countryName}`] }</th>
                            </tr>
                            <tr>
                                <td>1. { this.props.literals['L20016'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.basicInfo) }</p>
                                </td>
                            </tr>
                            <tr>
                                <td>2. { this.props.literals['L20017'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.background) }</p>
                                </td>
                            </tr>
                            <tr>
                                <td>3. { this.props.literals['L20018'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.characteristicsObjectives) }</p>
                                </td>
                            </tr>
                            <tr>
                                <td>4. { this.props.literals['L20019'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.detailsActivity) }</p>
                                </td>
                            </tr>
                            <tr>
                                <td>5. { this.props.literals['L20020'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.actorsStakeholders) }</p>
                                </td>
                            </tr>
                            <tr>
                                <td>6. { this.props.literals['L20021'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.resourcesTimeframe) }</p>
                                </td>
                            </tr>
                            <tr>
                                <td>7. { this.props.literals['L20022'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.evaluation) }</p>
                                </td>
                            </tr>
                            <tr>
                                <td>8. { this.props.literals['L20023'] }</td>
                                <td>
                                    <p>{ ReactHtmlParser(this.state.relationStategicFramework) }</p>
                                </td>
                            </tr>
                        </table>
                        <ul className="notes">
                            {
                                this.state.noteLinks.map( ( link, index ) => (
                                    <li key={ index }>
                                        <a href={ `#B${ index+1 }` } name={`_ftn${ index+1 }`}><sup>{ index+1 }</sup></a>
                                        <a href={ link }>{ link }</a>
                                    </li>
                                ))
                            }
                        </ul>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>
                        <p className="">European Agency for Safety and Health at Work – EU-OSHA</p>
                    </td>
                </tr>
            </tfoot>
        </table>
        )
    }
}
NationalStrategiesReport.displayName='NationalStrategiesReport';
export default NationalStrategiesReport;